export const timezones = [
	{
		"label":"Coordinated Universal Time-11 (GMT-11:00)",
		"tzCode":"Pacific/Midway",
		"name":"(GMT-11:00) Midway",
		"utc":"-11:00"
	},
	{
		"label":"Hawaiian Standard Time (GMT-10:00)",
		"tzCode":"Pacific/Honolulu",
		"name":"(GMT-10:00) Honolulu, East Honolulu, Pearl City, Hilo, Kailua",
		"utc":"-10:00"
	},
	{
		"label":"Marquesas Standard Time (GMT-09:30)",
		"tzCode":"Pacific/Marquesas",
		"name":"(GMT-09:30) Taiohae",
		"utc":"-09:30"
	},
	{
		"label":"Alaskan Standard Time (GMT-09:00)",
		"tzCode":"America/Anchorage",
		"name":"(GMT-09:00) Anchorage, Fairbanks, Eagle River, Badger, Knik-Fairview",
		"utc":"-09:00"
	},
	{
		"label":"Pacific Standard Time (GMT-08:00)",
		"tzCode":"America/Los_Angeles",
		"name":"(GMT-08:00) Los Angeles, San Diego, San Jose, San Francisco, Seattle",
		"utc":"-08:00"
	},
	{
		"label":"Mountain Standard Time (GMT-07:00)",
		"tzCode":"America/Boise",
		"name":"(GMT-07:00) Boise, Meridian, Nampa, Idaho Falls, Pocatello",
		"utc":"-07:00"
	},
	{
		"label":"Central Standard Time  (GMT-06:00)",
		"tzCode":"America/Regina",
		"name":"(GMT-06:00) Saskatoon, Regina, Prince Albert, Moose Jaw, North Battleford",
		"utc":"-06:00"
	},
	{
		"label": "Eastern Standard Time (GMT-05:00)",
		"tzCode": "America/New_York",
		"name": "(GMT-05:00) New York, Washington D.C., Miami, Atlanta, Boston",
		"utc": "-05:00"
	},	
	{
		"label":"Atlantic Standard Time (GMT-04:00)",
		"tzCode":"America/Glace_Bay",
		"name":"(GMT-04:00) Sydney, Glace Bay, Sydney Mines",
		"utc":"-04:00"
	},
	{
		"label":"Newfoundland Standard Time (GMT-03:30)",
		"tzCode":"America/St_Johns",
		"name":"(GMT-03:30) St. John's, Mount Pearl, Corner Brook, Conception Bay South, Bay Roberts",
		"utc":"-03:30"
	},
	{
		"label":"Argentina Standard Time (GMT-03:00)",
		"tzCode":"America/Buenos_Aires",
		"name":"(GMT-03:00) Buenos Aires, La Plata, Mar del Plata, Morón, Bahía Blanca",
		"utc":"-03:00"
	},
	{
		"label":"Coordinated Universal Time-02(GMT-02:00)",
		"tzCode":"Etc/GMT+2",
		"name":"(GMT-02:00) Coordinated Universal Time-02",
		"utc":"-02:00"
	},
	{
		"label":"Azores Standard Time (GMT-01:00)",
		"tzCode":"Atlantic/Azores",
		"name":"(GMT-01:00) Ponta Delgada, Lagoa, Angra do Heroísmo, Rosto de Cão, Rabo de Peixe",
		"utc":"-01:00"
	},
	{
		"label":"Greenwich Mean Time (GMT+00:00)",
		"tzCode":"Etc/Greenwich",
		"name":"(GMT+00:00) Abidjan, Abobo, Bouaké, Daloa, San-Pédro",
		"utc":"+00:00"
	},
	{
		"label":"Central European Standard Time (GMT+01:00)",
		"tzCode":"Europe/Sarajevo",
		"name":"(GMT+01:00) Sarajevo, Banja Luka, Zenica, Tuzla, Mostar",
		"utc":"+01:00"
	},
	{
		"label":"Eastern European Standard Time (GMT+02:00)",
		"tzCode":"Asia/Nicosia",
		"name":"(GMT+02:00) Nicosia, Limassol, Larnaca, Stróvolos, Paphos",
		"utc":"+02:00"
	},
	{
		"label":"Arabic Standard Time (GMT+03:00)",
		"tzCode":"Asia/Baghdad",
		"name":"(GMT+03:00) Baghdad, Basrah, Al Mawşil al Jadīdah, Al Başrah al Qadīmah, Mosul",
		"utc":"+03:00"
	},
	{
		"label":"Iran Standard Time (GMT+03:30)",
		"tzCode":"Asia/Tehran",
		"name":"(GMT+03:30) Tehran, Mashhad, Isfahan, Karaj, Tabriz",
		"utc":"+03:30"
	},
	{
		"label":"Arabian Standard Time (GMT+04:00)",
		"tzCode":"Asia/Dubai",
		"name":"(GMT+04:00) Dubai, Sharjah, Abu Dhabi, Ajman City, Ras Al Khaimah City",
		"utc":"+04:00"
	},
	{
		"label":"Afghanistan Standard Time (GMT+04:30)",
		"tzCode":"Asia/Kabul",
		"name":"(GMT+04:30) Kabul, Kandahār, Mazār-e Sharīf, Herāt, Jalālābād",
		"utc":"+04:30"
	},
	{
		"label":"West Asia Standard Time (GMT+05:00)",
		"tzCode":"Asia/Tashkent",
		"name":"(GMT+05:00) Tashkent, Namangan, Andijon, Qo‘qon, Chirchiq",
		"utc":"+05:00"
	},
	{
		"label":"India Standard Time (GMT+05:30)",
		"tzCode":"Asia/Kolkata",
		"name":"(GMT+05:30) Mumbai, Delhi, Bengaluru, Kolkata, Chennai",
		"utc":"+05:30"
	},
	{
		"label":"Nepal Standard Time (GMT+05:45)",
		"tzCode":"Asia/Kathmandu",
		"name":"(GMT+05:45) Kathmandu, Pokhara, Pātan, Biratnagar, Birgañj",
		"utc":"+05:45"
	},
	{
		"label":"Central Asia Standard Time (GMT+06:00)",
		"tzCode":"Asia/Almaty",
		"name":"(GMT+06:00) Almaty, Karagandy, Shymkent, Taraz, Nur-Sultan",
		"utc":"+06:00"
	},
	{
		"label":"Myanmar Standard Time (GMT+06:30)",
		"tzCode":"Asia/Yangon",
		"name":"(GMT+06:30) Yangon, Mandalay, Nay Pyi Taw, Mawlamyine, Kyain Seikgyi Township",
		"utc":"+06:30"
	},
	{
		"label":"SE Asia Standard Time (GMT+07:00)",
		"tzCode":"Asia/Bangkok",
		"name":"(GMT+07:00) Bangkok, Hanoi, Haiphong, Samut Prakan, Mueang Nonthaburi",
		"utc":"+07:00"
	},
	{
		"label":"China Standard Time (GMT+08:00)",
		"tzCode":"Asia/Shanghai",
		"name":"(GMT+08:00) Shanghai, Beijing, Tianjin, Guangzhou, Shenzhen",
		"utc":"+08:00"
	},
	{
		"label":"Aus Central W. Standard Time (GMT+08:45)",
		"tzCode":"Australia/Eucla",
		"name":"(GMT+08:45) Eucla",
		"utc":"+08:45"
	},
	{
		"label":"Japan Standard Time (GMT+09:00)",
		"tzCode":"Asia/Tokyo",
		"name":"(GMT+09:00) Tokyo, Yokohama, Osaka, Nagoya, Sapporo",
		"utc":"+09:00"
	},
	{
		"label":"Central Australia Standard Time (GMT+09:30)",
		"tzCode":"Australia/Adelaide",
		"name":"(GMT+09:30) Adelaide, Adelaide Hills, Mount Gambier, Morphett Vale, Gawler",
		"utc":"+09:30"
	},
	{
		"label":"E. Australia Standard Time (GMT+10:00)",
		"tzCode":"Australia/Brisbane",
		"name":"(GMT+10:00) Brisbane, Gold Coast, Logan City, Townsville, Cairns",
		"utc":"+10:00"
	},
	{
		"label":"Lord Howe Standard Time (GMT+10:30)",
		"tzCode":"Australia/Lord_Howe",
		"name":"(GMT+10:30) Lord Howe",
		"utc":"+10:30"
	},
	{
		"label":"Central Pacific Standard Time (GMT+11:00)",
		"tzCode":"Pacific/Noumea",
		"name":"(GMT+11:00) Central Pacific Standard Time",
		"utc":"+11:00"
	},
	{
		"label":"New Zealand Standard Time (GMT+12:00)",
		"tzCode":"Pacific/Auckland",
		"name":"(GMT+12:00) Auckland, Wellington, Christchurch, Manukau City, North Shore",
		"utc":"+12:00"
	},
	{
		"label":"Chatham Islands Standard Time (GMT+12:45)",
		"tzCode":"Pacific/Chatham",
		"name":"(GMT+12:45) Waitangi",
		"utc":"+12:45"
	},
	{
		"label":"Tonga Standard Time (GMT+13:00)",
		"tzCode":"Pacific/Tongatapu",
		"name":"(GMT+13:00) Nuku‘alofa, Lapaha, Neiafu, Pangai, ‘Ohonua",
		"utc":"+13:00"
	},
	{
		"label":"Line Islands Standard Time (GMT+14:00)",
		"tzCode":"Pacific/Kiritimati",
		"name":"(GMT+14:00) Kiritimati",
		"utc":"+14:00"
	}
]